import { render, staticRenderFns } from "./EditTab.vue?vue&type=template&id=03c49f55&scoped=true&"
import script from "./EditTab.vue?vue&type=script&lang=js&"
export * from "./EditTab.vue?vue&type=script&lang=js&"
import style0 from "./EditTab.vue?vue&type=style&index=0&id=03c49f55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c49f55",
  null
  
)

export default component.exports